import axios from 'axios';
import { getApiUrl } from '@/constants';

// Determine the base URL based on the environment
const baseURL = getApiUrl();

// Create an instance of Axios with the determined base URL
export const StnAPI = axios.create({
  baseURL,
  timeout: 200000,
});
